var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("header-sales"),
      _vm._v(" "),
      _c("div", { attrs: { id: "subheader" } }),
      _vm._v(" "),
      _c("div", { attrs: { id: "main-container" } }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { attrs: { id: "container" } }, [
          _c("div", { attrs: { id: "header-pedido" } }, [
            _c("div", { attrs: { id: "header-pedidoL" } }, [
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: false,
                      expression: "false"
                    }
                  ],
                  staticClass: "label-total"
                },
                [_vm._v("Pedido  ")]
              ),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.numPedido,
                    expression: "numPedido"
                  },
                  {
                    name: "show",
                    rawName: "v-show",
                    value: false,
                    expression: "false"
                  }
                ],
                class: { inputReadonly: !_vm.numPedidoEdit },
                attrs: {
                  id: "nPedido-edit",
                  type: "text",
                  readonly: !_vm.numPedidoEdit
                },
                domProps: { value: _vm.numPedido },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.numPedido = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c("img", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: false,
                    expression: "false"
                  }
                ],
                staticClass: "menu",
                attrs: { id: "icon", src: "/dist/icon-editar.png" }
              })
            ]),
            _vm._v(" "),
            _c("div", { attrs: { id: "header-pedidoR" } }, [
              _c("span", { staticClass: "label-subtotal" }, [
                _vm._v(
                  "Subtotal: $" +
                    _vm._s(_vm._f("formatMoney")(_vm.subtotal)) +
                    "    "
                )
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "label-subtotal" }, [
                _vm._v(
                  "Descuentos: $" +
                    _vm._s(_vm._f("formatMoney")(_vm.descuentos)) +
                    "    "
                )
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "label-total" }, [
                _vm._v(
                  "Total: $" +
                    _vm._s(
                      _vm._f("formatMoney")(_vm.subtotal - _vm.descuentos)
                    ) +
                    " "
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { id: "list-container" } },
            _vm._l(_vm.items, function(item) {
              return _c("item-pedido", {
                attrs: { id: "list-prod", item: item },
                on: { eliminarItem: _vm.btnEliminarItem }
              })
            })
          ),
          _vm._v(" "),
          _c("div", { attrs: { id: "btnContainer" } }, [
            _c("input", {
              attrs: { id: "btnEliminar", type: "submit", value: "ELIMINAR" },
              on: { click: _vm.btnEliminar }
            }),
            _vm._v(" "),
            _c("input", {
              attrs: { id: "btnGuardar", type: "submit", value: "GUARDAR" },
              on: { click: _vm.btnGuardar }
            }),
            _vm._v(" "),
            _c("input", {
              attrs: {
                id: "btnAgregar",
                type: "submit",
                value: "AGREGAR ITEM"
              },
              on: { click: _vm.btnAgregar }
            }),
            _vm._v(" "),
            _c("input", {
              attrs: { id: "btnEnviar", type: "submit", value: "ENVIAR" },
              on: { click: _vm.btnEnviar }
            })
          ])
        ])
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fadePro" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showPopup,
                expression: "showPopup"
              }
            ],
            attrs: { showPopup: _vm.showPopup }
          },
          [
            _c("div", { attrs: { id: "back-popup" } }),
            _vm._v(" "),
            _c("div", { attrs: { id: "popup" } }, [
              _c("div", { attrs: { id: "popup-btnClose-container" } }, [
                _c("img", {
                  staticStyle: { width: "20px", height: "20px" },
                  attrs: { id: "btnClose", src: "/dist/btnClose.png" },
                  on: { click: _vm.btnCerrarPopup }
                })
              ]),
              _vm._v(" "),
              _c("p", { attrs: { id: "popup-titulo" } }, [
                _vm._v("Enviar Pedido")
              ]),
              _vm._v(" "),
              _c("div", { attrs: { id: "comboContainer" } }, [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.sucursal,
                        expression: "sucursal"
                      }
                    ],
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.sucursal = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      }
                    }
                  },
                  [
                    _c("option", { attrs: { value: "", disabled: "" } }, [
                      _vm._v("Seleccione Dirección")
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.sucursales, function(option) {
                      return _c("option", { domProps: { value: option } }, [
                        _vm._v(_vm._s(option.Direccion))
                      ])
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.observaciones,
                      expression: "observaciones"
                    }
                  ],
                  attrs: { id: "obs", placeholder: "Ingrese observación" },
                  domProps: { value: _vm.observaciones },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.observaciones = $event.target.value
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { attrs: { id: "btnContainerPopup" } }, [
                _c("input", {
                  staticClass: "botonPopup",
                  attrs: {
                    id: "btnCerrarPopup",
                    type: "submit",
                    value: "CANCELAR"
                  },
                  on: { click: _vm.btnCerrarPopup }
                }),
                _vm._v(" "),
                _c("input", {
                  staticClass: "botonPopup",
                  attrs: {
                    id: "btnEnviarPopup",
                    type: "submit",
                    value: "ENVIAR"
                  },
                  on: { click: _vm.btnEnviarPopup }
                })
              ])
            ])
          ]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { attrs: { id: "label-container" } }, [
      _c("span", { attrs: { id: "label" } }, [_vm._v("Carrito de Compras")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1983740e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1983740e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/pedido/pedido.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-1983740e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/pedido/pedido.vue
// module chunks = 0